import * as Q from "q";
import * as globalConfig from "globalConfig";

// Models
import { PhoneConfigurationResponse } from "Content/ts/Models/Account/Profile/profileConfiguration";
import { PhoneNumberFormatRequestModel } from "Content/ts/Models/Account/Validation/PhoneNumberExampleRequestModel";
import { ValidatePhoneNumberRequestModel } from "Content/ts/Models/Account/Validation/ValidatePhoneNumberRequestModel";

export module InputValidationService {
    export function RetrievePhoneNumberConfiguration(): Q.Promise<PhoneConfigurationResponse> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Profile.PhoneConfiguration,
            type: "GET",
            cache: false
        }));
    };

    export function GetPhoneNumberFormatHelpText(request: PhoneNumberFormatRequestModel): Q.Promise<string> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Validation.PhoneFormatHelpText,
            type: "GET",
            cache: false,
            data: request
        }));
    };

    export function ValidatePhoneNumber(request: ValidatePhoneNumberRequestModel): Q.Promise<boolean> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Validation.ValidatePhoneNumber,
            type: "POST",
            cache: false,
            data: request
        }));
    };
}